<script>
import bus from 'vue3-eventbus'
export default {
  props: {
    level: Number
  },
  data () {
    return {
      userData: {},
      levelPic: [
        require('@/assets/level_big_bronze.png'),
        require('@/assets/level_big_silver.png'), require('@/assets/level_big_gold.png'),
        require('@/assets/level_big_platinum.png'), require('@/assets/level_big_diamond.png'),
        require('@/assets/level_big_king.png')],
      levelTxtBg: [
        require('@/assets/bronze_txt_bg.png'),
        require('@/assets/silver_txt_bg.png'), require('@/assets/gold_txt_bg.png'),
        require('@/assets/platinum_txt_bg.png'), require('@/assets/diamond_txt_bg.png'),
        require('@/assets/king_txt_bg.png')],
      levelTxt:[
        "Bronze","Silver","Gold","Platinum","Diamond","King"
      ],
      levelAffiliates:[
        "(-)","(A)","(A+B)","(A+B+C)","(A+B+C+D)","(A+B+C+D)"
      ],
      levelRate:[
        "5%","6%","7%","8%","10%","10%"
      ]
    }
  },
  computed: {
    levels () {
      console.log(this.$store.state.appConfig)
      return this.$store.state.appConfig.level ? this.$store.state.appConfig.level : []
    }
  },
  methods: {
    toRulesDetail() {
      this.$router.push('/rulesDetail')
    },
    dissmiss () {
      bus.emit('dismissLevelUp')
    },
    nomal () {
    }
  },
  mounted () {
    const user = this.$store.state.user
    if (user) {
      this.userData = user
    }
  },
}
</script>
<template>
  <div class="root">
    <img src="@/assets/iv_levelup_title.png">
    <p>Upgrade to {{ levelTxt[level] }} successfully</p>
    <p>More commission is on the way.</p>
    <div class="level-bg"></div>
    <div class="level-img" :style="{ 'background-image': 'url(' + levelPic[level] + ')' }"></div>
    <div class="level-txt" :style="{ 'background-image': 'url(' + levelTxtBg[level] + ')' }"></div>
    <div class="level-rate">
      <img style="width: 6.9rem; height: 6.9rem;" src="@/assets/iv_levelup_invitation.png">
      <div style="display: flex; flex-direction: column; margin-left: 2rem; margin-right: 2rem;">
        <div style="display: flex; flex-direction: row; align-items: center;justify-items: center;">
          <p style="font-size: 2rem; color: white;">Level {{ level }}</p>
          <img src="@/assets/iv_arrow.png">
          <p style="color: #FFF954; font-size: 2rem;">{{ levelAffiliates[level] }}</p>
        </div>
        <p style="color: #CDB8FF; font-size: 2rem;">Invitation Commission</p>
      </div>


      <img style="width: 6.9rem; height: 6.9rem;" src="@/assets/iv_levelup_recharge.png">
      <div style="display: flex; flex-direction: column; margin-left: 2rem;">
        <div style="display: flex; flex-direction: row; align-items: center;justify-items: center;">
          <p style="font-size: 2rem; color: white;">{{ levelRate[level-1>=0?level-1:level] }}</p>
          <img src="@/assets/iv_arrow.png">
          <p style="color: #FFF954; font-size: 2rem;">{{ levelRate[level] }}</p>
        </div>
        <p style="color: #CDB8FF; font-size: 2rem;">Recharge Commission</p>
      </div>
    </div>

    <div style="display: flex; flex-direction: row; align-self: center; margin-top: 2rem;">
      <p class="positive"  @click="dissmiss">Cancel</p>
      <p class="negative" @click="toRulesDetail">See More</p>
    </div>

  </div>
</template>

<style scoped>


.level-img {
  position: absolute;
  height: 27rem;
  width: 27rem;
  background-size: cover;
  background-repeat: no-repeat;
  align-self: center;
  margin-top: 10rem;
}

.level-rate {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  align-self: center;
  margin-top: 2rem;
}

.positive {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  font-weight: 400;
  line-height: 6rem;
  background-image: url("@/assets/bg_logout_confirm.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
}

.positive:active {
  opacity: 0.6;
}

.negative {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  line-height: 6rem;
  font-weight: 400;
  margin-left: 5rem;
  background-image: url("@/assets/bg_logout_cancel.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
}

.negative:active {
  opacity: 0.6;
}

.level-bg {
  width: 47rem;
  height: 24.8rem;
  background-image: url("@/assets/bg_level_rule_light.png");
  background-size: cover;
  background-repeat: no-repeat;
  pointer-events: none;
  align-self: center;
}

.level-txt {
  width: 24.2rem;
  height: 5.8rem;
  line-height: 5rem;
  font-size: 2.8rem;
  text-align: center;
  background-image: url("@/assets/diamond_txt_bg.png");
  background-size: 100% 100%;
  color: white;
  font-weight: bolder;
  z-index: 0;
  margin-top: -6rem;
  align-self: center;
}

.root {
  width: 94.8rem;
  height: 56.9rem;
  background-image: url("@/assets/bg_levelup.png");
  background-size: 100% 95%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-self: center;
  justify-self: center;
}

.root > img {
  width: 61.9rem;
  height: 9rem;
  align-self: center;
}

.root > p {
  width: auto;
  height: auto;
  align-self: center;
  color: #C49DFF;
  font-size: 2.4rem;
  font-weight: 600;
  align-content: center;
  justify-content: center;
}

.root > img:active {
  opacity: 0.6;
}



.no-border-right {
  border-right: 0 solid transparent;
}

.img-contain {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.img-cell {
  background-size: cover;
}

.cell-bg {
  background-color: #F3B25633;
}
</style>
